function isDev () {
  return window.location.hostname.split('.')[0] === 'localhost'
}
function isStaging () {
  return ['dmpi2', 'dfx-dmpi2'].includes(window.location.hostname.split('.')[0])
}

export const baseUrl = (() => {
  if (isDev() || isStaging()) {
    return 'https://test2dmpiapi.dealer-fx.com'
    //return 'https://localhost:51556'
  } else {
    return '#{ApiUrl}#'
  }
})()
export const scope = (() => {
  if (isDev() || isStaging()) {
    return 'TEST2_DynamicAPIUser'
  } else {
    return '#{DmpiScope}#'
  }
})()
export const logBaseUrl = (() => {
  if (isDev() || isStaging()) {
    return 'https://test2dmpiapi.dealer-fx.com'
    // return 'http://localhost:57297'
  } else {
    return '#{UserActivityLog}#'
  }
})()
export const pendoEnv = (() => {
  if (isDev() || isStaging()) {
    return 'DEV'
  } else {
    return '#{PendoEnvironment}#'
  }
})()
export const stripeCadPublishableKey = (() => {
  if (isDev() || isStaging()) {
    return 'pk_test_51GsYf4Gqn6YxWkO0IUevgzby86bMP1IFR6NesBxBYY5UtnbngsEmGldGWXCx3PNyw6Yupi7gjI3Qsj3TjHcO2uIo00NZw1pDQA'
  } else {
    return '#{stripeCadPublishableKey}#'
  }
})()
export const stripeUsdPublishableKey = (() => {
  if (isDev() || isStaging()) {
    return 'pk_test_51Lz0XTE0qOf4q8aI8yLo29NsA7qI6Vtv7RUYbVZplRVTw1zeIQHoECUx9bl0U5hsC2MdiOWg385URT9UBd3seVUj00SJvzzQlt'
  } else {
    return '#{stripeUsdPublishableKey}#'
  }
})()

export default {
  baseUrl,
  scope,
  logBaseUrl,
  pendoEnv,
  stripeCadPublishableKey,
  stripeUsdPublishableKey
}
